(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inter-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', async () => {
const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('id');
    const snapshotId = urlParams.get('snapshotId');
    const signature = urlParams.get('signature');
    const statusWrapper = document.querySelector('#inter-cart-status');

    const setStatus = async (status) => {
      // Only wait for transition if opacity isn't already 0
      if (statusWrapper.style.opacity !== '0') {
        statusWrapper.style.opacity = '0';

        await new Promise((resolve) => {
          const handleTransition = () => {
            statusWrapper.removeEventListener('transitionend', handleTransition);
            resolve();
          };

          statusWrapper.addEventListener('transitionend', handleTransition);

          // Fallback timeout in case transition doesn't fire
          setTimeout(() => {
            statusWrapper.removeEventListener('transitionend', handleTransition);
            resolve();
          }, 250);
        });
      }

      statusWrapper.innerText = status;

      // Force reflow to ensure transition happens
      void statusWrapper.offsetWidth;

      statusWrapper.style.opacity = '1';
    };

    if (!variantId || !snapshotId || !signature) {
      alert('Variant ID, Snapshot ID or Signature is not valid');
      window.location.href = '/';
      return;
    }

    const _signatureResponse = await fetch(`https://memotions-middleware-api.info-d8e.workers.dev/api/validate/${snapshotId}?signature=${signature}`);

    if (!_signatureResponse.ok) {
      alert('Invalid signature');
      window.location.href = '/';
      return;
    }

    const payload = {
      id: variantId,
      quantity: 1,
    };



  try {
  await setStatus('Žiedai dedami į krepšelį');

  const res = await fetch('/cart/add.js?source=inter-cart', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  });

  // Check if it actually succeeded
  if (!res.ok) {
    const error = await res.json();
    console.error('Cart error:', error);
    return;
  }

  const data = await res.json(); // fully consume the response
  console.log('Added to cart:', data);

  await setStatus('Nukreipiame į krepšelį');
  window.location.href = '/cart'; // no need for setTimeout
} catch (err) {
  console.error(err);
}
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
